<template>
	<vx-card>
		<vs-input
			class="w-full mb-4"
			v-validate="'required'"
			data-vv-validate-on="blur"
			label="Название категории"
			name="Название категории"
			v-model="category.name"
			/>
		<span class="text-danger text-sm">{{ errors.first('Название категории') }}</span>


		<label class="vs-input--label">Статус</label>
		<ul class="flex">
			<li><vs-radio class="mr-5" v-model="category.is_closed" vs-name="categoryStatus" :vs-value="false">Открыто</vs-radio></li>
			<li><vs-radio class="" v-model="category.is_closed" vs-name="categoryStatus" :vs-value="true">Закрыто</vs-radio></li>
		</ul>
		<span class="text-danger text-sm">{{ errors.first('Статус') }}</span>

		<picture-input 
			ref="pictureInput" 
			@change="onChange"
			name="Изображение категории"
			width="200" 
			height="200" 
			margin="1" 
			accept="image/svg,image/svg+xml" 
			size="15" 
			buttonClass="vs-component vs-button vs-con-loading__container vs-button-primary vs-button-relief"
			:prefill="category.image"
			:customStrings="{
				upload: '<h1>Загрузить изображение</h1>',
				drag: 'Загрузите изображение',
				change: 'Изменить изображение',
				remove: 'Удалить изображение',
				select: 'Выбрать изображение',
			}">
		</picture-input>
		<span class="text-danger text-sm">{{ errors.first('Изображение категории') }}</span>

		<vs-button
			@click="updateCategory"
			:disabled="!validateForm"
			class="mr-5 vs-con-loading__container"
			ref="loadableButton"
			type="relief"
			vslor="primary"
			>
			Обновить
		</vs-button>

		<vs-button
			@click="deleteCategory"
			class="vs-con-loading__container"
			ref="loadableButton"
			type="relief"
			color="danger"
			>
			Удалить
		</vs-button>

	</vx-card>
</template>

<script>
import { API_URL } from '@/.env'
import PictureInput from 'vue-picture-input'

export default {
  data: () => ({
    BASE_URL: API_URL,
	activeCreatePrompt: false,
	category: [],
  }),
  components: {
	PictureInput
  },
  watch: {},
  computed: {
	validateForm () {
      return !this.errors.any() && this.category.name !== '' && this.category.image !== null
	},
  },
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    formatDate(date) {
      let now = new Date(date);

      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };

      return now.toLocaleString("ru-ru", options);
	},
	onChange() {
		let payload = {
			imageFile: this.$refs.pictureInput.file
		}
		
		this.uploadImage(payload);
	},
	uploadImage(data) {
		this.$load(async () => {
			let res = (await this.$api.services.updateServicesImage(this.$route.params.id, data));
			
			if(res.status == 200) {
				this.notification(
					"Успешно",
					'Изображение успешно обновлено',
					"success"
				  );
			} else {
				this.notification(
					"Ошибка",
					'Не удалось обновить изображение',
					"danger"
          		);
			}
		});
	},
	updateCategory() {
		let payload = {
			name: this.category.name,
			is_closed: this.category.is_closed
		}

		this.$load(async () => {
			let res = (await this.$api.services.updateCategory(this.$route.params.id, payload));
			
			if(res.status == 200) {
				this.notification(
					"Успешно",
					'Категория обновлена',
					"success"
				  );
			} else {
				this.notification(
					"Ошибка",
					'Не удалось обновить категорию',
					"danger"
          		);
			}
		});
	},
	deleteCategory() {
		let idCategory = this.$route.params.id;

		this.$load(async () => {
			await this.$api.services.deleteCategory(idCategory).then(response => {
				if(response.status == 200) {
					this.notification(
						"Успешно",
						'Категория удалена',
						"success"
					);
					this.$router.push({ name: 'services-categories' })
				}
				else {
					this.notification(
						"Ошибка",
						'Не удалось удалить категорию',
						"danger"
					);
				}
			});
		});
	},
	getCategory(idCategory) {
		this.$load(async () => {
			let res = (await this.$api.services.getCategory(idCategory)).data;

			let category = res;

			category.date_created = this.formatDate(category.date_created);
			category.image = category.image !== null ? this.BASE_URL + category.image : '';

			this.category = category;
		});
	}
  },
  created() {},
  mounted() {
    this.getCategory(this.$route.params.id);
  },
};
</script>